module.exports = __webpack_public_path__ + "img/workers.8fd7d3ff.png";